import { CLIENT_TYPE_HEADER, CLIENT_TYPE } from 'harmony/lib/constants';
import { isEmpty } from 'lodash/fp';

const baseUrl = process.env.REACT_APP_BACKEND_URL;
const defaultHeaders = {
  'Content-Type': 'application/json',
  Accept: 'application/json',
  [CLIENT_TYPE_HEADER]: CLIENT_TYPE.ONLINE,
};

/**
 * Parses the JSON returned by a network request
 *
 * @param  {object} response A response from a network request
 *
 * @return {object}          The parsed JSON from the request
 */
async function parseJSON(response) {
  const text = await response.text();
  return isEmpty(text) ? {} : JSON.parse(text);
}

/**
 * Checks if a network request came back fine, and throws an error if not
 *
 * @param  {object} response   A response from a network request
 *
 * @return {object|undefined} Returns either the response, or throws an error
 */
function checkStatus(response) {
  if (response.status >= 200 && response.status < 300) {
    return response;
  }

  const error = new Error(response.statusText);
  error.response = response;
  throw error;
}

/**
 * Requests a URL, returning a promise
 *
 * @param  {string} url       The URL we want to request
 * @param  {object} [options] The options we want to pass to "fetch"
 *
 * @return {object}           The response data
 */
export default function request(url, options) {
  const completeUrl = `${baseUrl}${url}`;
  return fetch(completeUrl, {
    ...options,
    headers: {
      ...defaultHeaders,
      ...(options || {}).headers,
    },
    'no-cors': true,
  })
    .then(checkStatus)
    .then(parseJSON);
}



// WEBPACK FOOTER //
// ./src/utils/request.js